import { CURRENCIES_FILED } from "../constants/currencies.constant";

const getCurrencyWithSymbol = (currency?: string | null, value: number = 0) => {
  const validCurrency = currency && CURRENCIES_FILED[currency as keyof typeof CURRENCIES_FILED] ? currency : "INR";
  const currencyData = CURRENCIES_FILED[validCurrency as keyof typeof CURRENCIES_FILED];

  const formattedValue = typeof value === "number" ? value.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : value;
  
  return currencyData.prefix === true
    ? [currencyData.symbol, formattedValue].join(" ")
    : [formattedValue, currencyData.symbol].join(" ");
};
export default getCurrencyWithSymbol;
